/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { findObjWithType } from '@odmonorepo/odfunctions';
import { Address, BusinessProfile } from 'merchant-api/types';
import { spiceroad } from '..';

export interface BusinessProps {
  isBusinessLoading: boolean;
  businessDetails: BusinessProfile | undefined;
  businessAddress: Address;
  businessPhoneNumber: string;
  isBusinessError: any;
  query: UseQueryResult<BusinessProfile>;
}

const getBusinessData = (businessId: string) =>
  spiceroad
    .get<BusinessProfile>(`/v1/businesses/${businessId}`)
    .then((res) => res.data);

const getBusinessOpts = (businessId: string) =>
  queryOptions<BusinessProfile>({
    queryKey: ['business', businessId],
    queryFn: () => getBusinessData(businessId),
  });

export function getBusiness(): BusinessProps {
  const { businessId, isErrorParties, isLoadingParties, isRenewal } =
    useParties();
  const query = useQuery({
    ...getBusinessOpts(businessId!),
    enabled: isRenewal && !!businessId,
  });
  const { data, error, isLoading } = query;
  return {
    businessDetails: data,
    businessAddress: findObjWithType(data?.addresses, 'PHYSICAL_ADDRESS'),
    businessPhoneNumber: findObjWithType(data?.contacts, 'PHONE_NUMBER')?.value,
    isBusinessLoading: isLoading || isLoadingParties,
    isBusinessError: error || isErrorParties,
    query,
  };
}

export default getBusiness;
